import resources from '@js/resources'
import BaseApi from '@js/api/base-api.js'

const resource = 'tenantUserLinks';

export default class ApiTenantUser extends BaseApi {
  constructor (tenantUserId, tenantUserLinkId = null) {
    super();
    this.name = 'ApiTenantUserLink';
    if (tenantUserLinkId instanceof Array) {
      this.urls = tenantUserLinkId.reduce((result, elem) => {
        result.push(resources[resource](
          this.getTenantDomain(), tenantUserId, elem));
        return result;
      }, []);
    } else {
      this.url = resources[resource](
        this.getTenantDomain(), tenantUserId, tenantUserLinkId);
    }
  }
}
